<template>
  <component :is="componentName" @scroll="onScroll" class="mic-com search-container">
    <div :style="style" class="search">
      <div class="input-layer">
        <div class="input-holder" :style="inputStyle" v-show="!onFocus">
          <van-icon name="search"/>
          <span>搜索商品</span>
        </div>
        <form action="" :style="inputStyle" @submit.prevent="onSearch">
          <input v-model="searchStr" @focus="onFocus=true" @blur="onFocus=false" type="search" ref="input"/>
        </form>
      </div>
    </div>
  </component>
</template>

<script>
  import Common from "../mixins/Common";

  // https://bkchina.h5.yunhuiyuan.cn/Shop/ShopList?bid=e02cbb7b-a9e7-e311-a603-90b11c47e695&name=123
  export default {
	name: "Search",
	props: {},
	mixins: [Common],
	components: {},
	data() {
	  return {
		scrollDirection: 0,
		tagListVisible: false,
		searchStr: '',
		onFocus: false
	  };
	},
	created() {
	  this.scrollTop = 0;
	  this.listenSibling();
	},
	methods: {
	  onScroll(e) {
		this.scrollDirection = e.scrollTop > this.scrollTop ? 1 : 0;
		this.scrollTop = e.scrollTop;
	  },
	  onSearch() {
		if (this.$IS_PREVIEW) return;
		const {bid} = this.$utils.param2Obj();
		const link = `${location.protocol}//${location.host}/Shop/ShopList?bid=${bid}&name=${this.searchStr}`;
		this.$refs['input'].blur();
		location.href = link;
	  },
	  listenSibling() {
		if (!this.$pub) return;
		this.$pub.$on('goods-tag-list-enter', this.whenTagListEnter);
		this.$pub.$on('goods-tag-list-leave', this.whenTagListLeave);
	  },

	  whenTagListEnter() {
		this.tagListVisible = true;
	  },
	  whenTagListLeave() {
		this.tagListVisible = false;
	  },
	},
	computed: {
	  componentName() {
		return this.config.position_type ? 'van-sticky' : 'div';
	  },
	  style() {
		return {
		  height: this.config.border_style_height + 10 + 'px',
		  backgroundColor: this.config.bg_color,
		  transform: this.translate
		};
	  },
	  translate() {
		if (this.tagListVisible) return 'translate(0,-100%)';
		if (this.config.position_type === 0) return '';
		if (this.config.position_show_method === 0) return '';
		return this.scrollDirection === 1 ? 'translate(0,-100%)' : '';
	  },
	  inputStyle() {
		return {
		  backgroundColor: this.config.border_style_color,
		  borderRadius: this.config.border_style_method ? this.config.border_style_height / 2 + 'px' : '4px',
		  justifyContent: this.config.text_align_method ? 'center' : 'flex-start',
		  textAlign: this.config.text_align_method ? 'center' : 'left',
		  webkitJustifyContent: this.config.text_align_method ? 'center' : 'flex-start',
		  color: this.config.text_color,
		};
	  }
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .search-container {
    position: relative;
  }

  .search {
    position: relative;
    transition: transform .3s;
    height: 40px;
    box-sizing: border-box;
    justify-content: center;

    .input-layer {
      position: absolute;
      bottom: 5px;
      right: 15px;
      top: 5px;
      left: 15px;
    }

    form {
      position: absolute;
      bottom: 0;
      right: 0;
      top: 0;
      left: 0;
      overflow: hidden;

      input {
        height: 100%;
        width: 100%;
        border: 0;
        text-align: center;
      }
    }

    .input-holder {

      pointer-events: none;
      touch-action: none;

      z-index: 1;
      position: absolute;
      bottom: 0;
      right: 0;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      padding-left: 15px;

      .van-icon {
        font-size: 22px;
        margin-right: 10px;
      }
    }
  }
</style>
